import { parse } from 'graphql'
import type { DocumentNode } from 'graphql'

/**
 * A `gql` tag built on graphql-js instead of `@apollo/client`.
 *
 * cinnamon imports `gql` from `@apollo/client`, which pulls React in through
 * the package's main entry — a non-starter for `core`. `parse` from the
 * `graphql` reference implementation produces the same `DocumentNode` that
 * Apollo Client (web) and any other transport accepts, and it runs under
 * Hermes, so the React Native port keeps these documents unchanged.
 *
 * Interpolated values are the shared field-selection strings in
 * `domain/types/graphql/fields`, so they are spliced in as raw GraphQL.
 */
export const gql = (
  strings: TemplateStringsArray,
  ...values: readonly string[]
): DocumentNode =>
  parse(
    strings.reduce(
      (source, chunk, index) => source + chunk + (values[index] ?? ''),
      '',
    ),
  )
